// material-ui
import { Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';

// ==============================|| SAMPLE PAGE ||============================== //

const SamplePage = () => (
    <MainCard title="Error">
        <Typography variant="body2">
            Ya tienes una sesión activa funcionando, cierra la otra sesión y recarga la página para continuar
        </Typography>
    </MainCard>
);

export default SamplePage;
